import { takeEvery } from 'redux-saga/effects';
import { fetchAppRolesMapping } from '../slice';
import { getAppRolesMapping } from './appRolesMappingsSaga';

const currentUserSagas = [takeEvery(fetchAppRolesMapping.type, getAppRolesMapping)];

export default currentUserSagas;
